var module = angular.module('components');
module.component('caArticleList', {
    templateUrl: 'components/genericcomponents/articlelist.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        articles: '=',
        filter: '=',
        currentPage: '=',
        pageSize: '=',
        onArticleSelected: '&',
        onNew: '&',
        showNewButton: '<',
        showFilterDropdown: '<',
        match : '=',
        inactive: '='
    },
    scope: true,
    controller: ['$state', '$stateParams', '$rootScope', '$scope', 'ProductsApiService', 'loadSpinnerService', controller]
});

function controller($state, $stateParams, $rootScope, $scope, ProductsApiService, loadSpinnerService) {
    var vm = this;
    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    //Properties
    vm.totalItems = [];
    vm.filterDropdownIsVisisble = false;
    vm.articleListIsVisible = true;
    vm.selectedArticleId = $state.params.articleId === undefined ? 0 : parseInt($state.params.articleId,10);
    vm.useElasticProductSearch = false;

    //Methods
    vm.loadArticles = loadArticles;
    vm.selectArticle = selectArticle;
    vm.getShowFilterDropDown = getShowFilterDropDown;
    vm.getSearchTooltipText = getSearchTooltipText;
    vm.searchTermChange = searchTermChange;
    vm.goToNew = goToNew;
    vm.forceReloadUrl = forceReloadUrl;
    vm.toggleHideArticleList = toggleHideArticleList;

    function onInit() {
        searchTermChange();

        loadArticles();

        $scope.$watch(function() { return $state.params.articleId; }, function(newValue, oldValue) {
            vm.selectedArticleId = parseInt($state.params.articleId,10);
        });
        var productChangedListener = $rootScope.$on('Product.Changed', function(event, response) {
            loadArticles();
        });
        $scope.$on('$destroy', function() {
            //Clean up usage of $rootScope listener when controller is destoyed
            productChangedListener();
        });
    }

    function onChanges(changes) {
    }

    function loadArticles() {
        if(vm.isLoading) return;

        vm.isLoading = true;

        var companyId; // companyId = undefined
        loadSpinnerService.start('mainSpinner');
        var request = {
            currentPage: vm.currentPage,
            filter: vm.filter,
            pageSize: vm.pageSize,
            companyId: companyId,
            showInactiveArticles: vm.inactive,
            matchEntireSearchTerm: vm.match
        };
        
        ProductsApiService.getProducts(request).then(function(response) {
            vm.articles = response.data.results;
            vm.totalItems = response.data.total;
            vm.pageSize = response.data.limit;
            vm.currentPage = response.data.page;

            if (_.find(response.links, function(o) { return o.rel === 'show_elastic_search'; })) {
                vm.useElasticProductSearch = true;
            }

            $stateParams.filter = vm.filter;
            $stateParams.currentPage = vm.currentPage;
            $stateParams.pageSize = vm.pageSize;
            $stateParams.inactive = vm.inactive;
            $stateParams.match = vm.match;
        }).finally(function afterGetAllArticles() {
            loadSpinnerService.stop('mainSpinner',{force: true});
            if (vm.currentPage === 1 && vm.articles.length === 1 && vm.totalItems === 1) {
                selectArticle(vm.articles[0]);
            }

            vm.isLoading = false;
        });
    }

    function toggleHideArticleList(){
        vm.articleListIsVisible = !vm.articleListIsVisible;
        $state.params.showArticleList = vm.articleListIsVisible;
    }

    function getSearchTooltipText() {
        var tooltipString = 'Sökning med partiella ord görs med en stjärna i slutet, ex. "Ja*" för "Jacka"';
        if (!vm.useElasticProductSearch) { tooltipString = ''; }

        return tooltipString;
    }

    function getShowFilterDropDown() {
        return vm.showFilterDropdown && !vm.useElasticProductSearch;
    }

    function goToNew() {
        vm.onNew();
    }

    function selectArticle(article) {
        vm.onArticleSelected({
            article: {
                articleId: article.id,
                searchTerms: {
                    currentPage: vm.currentPage,
                    pageSize: vm.pageSize,
                    filter: vm.filter,
                    inactive: vm.inactive,
                    match: vm.match
                }
            }
        });
    }

    function searchTermChange() {
        if (vm.isLoading) { return; }

        if ($stateParams.filter && $stateParams.filter !== vm.filter) {
            vm.currentPage = 1;
        }

        vm.filter = vm.filter.replace(/#/g, "");

        $stateParams.filter = vm.filter;
        $stateParams.currentPage = vm.currentPage;
        $stateParams.pageSize = vm.pageSize;
        $stateParams.inactive = vm.inactive;
        $stateParams.match = vm.match;

        forceReloadUrl();

        if (vm.filter.length > 2) {
            loadArticles();
        } else if (vm.filter.length === 0) {
            loadArticles();
        }
    }

    function forceReloadUrl(){
        $state.go($state.current.name, 
        {
            articleId: vm.selectedArticleId,
            currentPage: vm.currentPage,
            pageSize: vm.pageSize,
            filter: vm.filter,
            inactive: vm.inactive,
            match: vm.match
        },
            {notify: false}
        );
    }
}
